module.exports = fox._r("images/small-logo.png", __webpack_public_path__ + "images/small-logo.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/small-logo.png
// module id = 1120
// module chunks = 4